<template>
  <div class="container-images">
    <div class="main-image">
      <img v-if="activeImage.length > 0" :src="activeImage" @click="showLightbox" />
      <div v-if="activeImage.length > 0" class="delete-photo" @click="onDeletePhoto"></div>
      <div v-if="activeImage.length > 0" class="show-photo-gallery" @click="showLightbox"></div>
      <div v-if="activeImage.length === 0" class="no-image"></div>
    </div>
    <div class="all-images">
      <div v-for="(image, index) in photos" :key="index" class="all-images__child">
        <template v-if="image.url">
          <div :class="{ 'image-checked': image.active }" class="all-images__child--img" @click="onClickImage(image)">
            <img v-if="image.url" :src="image.url" />
          </div>
        </template>
        <template v-else>
          <div :class="{ 'image-checked': image.active }" class="all-images__child--img" @click="onAddImage(image)">
            <div v-if="!image.url" class="add-image"></div>
          </div>
        </template>
      </div>
    </div>
    <div class="upload-image">
      <input
        ref="inputUploadImage"
        type="file"
        name="pic"
        accept=".gif, .jpeg, .png, image/gif, image/jpeg, image/png"
        @change="onChangeUpload($event)"
      />
    </div>

    <lightbox id="mylightbox" ref="lightbox" :images="galleryPhotos" />
  </div>
</template>

<script>
import Lightbox from "vue-my-photos/src/lightbox.vue";
import { mapActions } from "vuex";

export default {
  name: "ContainerImageInfinitely",
  components: { Lightbox },
  props: {
    value: {
      type: Array,
      default: () => []
    },
    fieldname: {
      type: String,
      default: ""
    },
    update: {
      type: Function,
      default: () => {}
    }
  },
  data() {
    return {
      attachments: [],
      lastClickedSide: "",
      activeImage: "",
      firstLoad: true
    };
  },
  computed: {
    photos: {
      get() {
        const vm = this;
        const newValue = JSON.parse(JSON.stringify([...vm.attachments, ...vm.value]));

        newValue.map((image, index) => {
          if (index === 0 && (vm.firstLoad || image.isNew)) {
            image.active = true;
            vm.activeImage = image.url;
            vm.lastClickedSide = image;
            vm.firstLoad = false;
          } else {
            image.isNew = false;
          }
        });

        newValue.push({
          side: "OTHER",
          image: "",
          id: 0
        });

        return newValue;
      },
      set() {
        // const imageElements = newValue.filter(s => s.url && s.url.length > 0);
        // this.$emit("update", {
        //   value: imageElements,
        //   fieldname: this.fieldname
        // });
      }
    },
    galleryPhotos: {
      get() {
        return this.photos
          .filter(photo => typeof photo.url !== "undefined")
          .map((photo, index) => ({
            name: photo.url,
            alt: photo.origin_filename,
            id: index
          }));
      }
    }
  },
  methods: {
    ...mapActions(["uploadImage", "deleteFile"]),
    getActiveImage() {
      this.activeImage = "";
      this.photos.map(s => {
        if (s.image.length > 0 && this.activeImage.length === 0) {
          s.active = true;
          this.activeImage = s.url;
          this.lastClickedSide = s;
        }
      });
    },
    onDeletePhoto() {
      const activeImage = this.photos.find(el => {
        return el.active;
      });
      const deletedArr = this.photos.filter(el => {
        return !el.active;
      });

      this.$emit("delete-file", activeImage.id);

      if (deletedArr != undefined && deletedArr.length > 1) {
        const firstEl = deletedArr[0];

        firstEl.active = true;
        this.activeImage = firstEl.url;
        this.lastClickedSide = firstEl;
        this.firstLoad = false;
      } else {
        this.activeImage = "";
      }
    },
    onClickImage(image) {
      this.activeImage = image.url;
      this.lastClickedSide = image;
      this.photos = this.photos.map(s => {
        if (s.id === image.id) {
          s.active = true;
        } else {
          s.active = false;
        }
        return s;
      });
    },
    onAddImage(side) {
      this.lastClickedSide = side;
      this.$refs.inputUploadImage.click();
    },
    onChangeUpload(e) {
      const file = e.target.files[0];
      const formData = new FormData();
      const vm = this;

      if (!file) {
        return;
      }

      formData.append("files", file);
      if (typeof this.$listeners.setUploadData !== "undefined") {
        this.$emit("set-upload-data", true);
      } else {
        this.$parent.uploadData = true;
      }

      this.uploadImage(formData).then(response => {
        const uploadData = response.data[0];

        vm.$emit("add-file", uploadData);
        if (typeof this.$listeners.setUploadData !== "undefined") {
          this.$emit("set-upload-data", false);
        } else {
          this.$parent.uploadData = false;
        }

        this.photos = this.photos.map(image => {
          if (image.id === this.lastClickedSide.id) {
            vm.activeImage = uploadData.url;
            vm.lastClickedSide = uploadData;
            image.url = uploadData.url;
            image.image = uploadData.id;
            image.active = true;
          } else {
            image.active = false;
          }
          return image;
        });
      });
      e.target.value = "";
    },
    showLightbox() {
      const imageName = this.activeImage;

      this.$refs.lightbox.show(imageName);
    }
  }
};
</script>
